import { useRouter } from '@tanstack/react-router';
import { FC, useEffect, useRef, useState } from 'react';
import { useLoginStore } from '@/shared/lib/store';
import { useCreateStore } from '@/entities/create';
import { CreateExitPopup } from '@/widgets/modal/ui/created-exit-popup';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { CreateNewSavePopup } from '@/widgets/modal/ui/created-newsave-popup';
import { showToast } from '@/shared/utils/toast';

export const GnbMenu: FC = () => {
    const {
        sTextbookList,
        sCurribook,
        type,
        setState,
        publishId,
        editExamName,
        editExamId,
        editBackType,
        setCurribook,
    } = useCreateStore();
    const dropdownRef = useRef<HTMLDivElement>(null); // 외부 클릭 감지를 위한 ref
    const { textbookId, setState: loginSetState } = useLoginStore();
    const router = useRouter();
    const { showModal } = useModalStore();
    const [isEditing, setIsEditing] = useState(false);
    const [title, setTitle] = useState(editExamName);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setIsEditing(true);
    const handleClose = () => setIsEditing(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState('editExamName', e.target.value);
        setTitle(e.target.value);
    };

    const onGoBack = () => {
        if (type === 'setMode') router.history.back();
        else showExitPopup();
    };

    const handleSave = () => {
        setState('requestSave', 'save');
    };

    const handleNewSave = () => {
        showModal({
            isCustom: true,
            id: 'create_newsave_popup',
            initContents: () => <CreateNewSavePopup />,
        });
    };

    const showExitPopup = () => {
        showModal({
            isCustom: true,
            id: 'create_exit_popup',
            initContents: () => (
                <CreateExitPopup
                    routeUrl={
                        editBackType === 'normal'
                            ? 'back'
                            : publishId
                              ? {
                                    to: `/sets/published-box/detail/${publishId}`,
                                    replace: true,
                                }
                              : {
                                    to: `/sets/created-box/detail/${editExamId}`,
                                    replace: true,
                                }
                    }
                />
            ),
        });
    };

    const onSave = () => {
        setState('editExamName', title);
        handleClose();
    };

    const handleChangeBook = (textbook: API.TextbookListbyCurriBook.TextbkListbyCurriBook) => {
        loginSetState('textbookId', textbook.id);
        setState('sCurribookId', textbook.curriBook);
        setState('curTextbookId', textbookId);
        setCurribook(textbook);
        if (type !== 'data') setState('type', 'setMode');
        setState;
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (title.length === 50) {
            showToast('자료명은 50자를 초과할 수 없습니다.', 2000, 'error');
        }
    }, [title]);

    return (
        <div className="gnbBox">
            <div className="gnbwid">
                {type === 'editMode' ? (
                    <div className="headerTitle">
                        {/*{!isEditing && (*/}
                        {/*    <>*/}
                        {/*        <h3 className="dataTitle">{editExamName}</h3>*/}

                        {/*        <button*/}
                        {/*            type="button"*/}
                        {/*            className="btn btn-icon edit_pencil"*/}
                        {/*            onClick={handleOpen}*/}
                        {/*        >*/}
                        {/*            <span className="blind">열기</span>*/}
                        {/*        </button>*/}
                        {/*    </>*/}
                        {/*)}*/}
                        <div className="data-list-layer input-txt" style={{ display: 'block' }}>
                            <label htmlFor="txt">
                                <input
                                    type="text"
                                    placeholder="자료명이 들어갑니다."
                                    title="자료명 입력"
                                    id="txt"
                                    value={title}
                                    maxLength={50}
                                    onChange={handleChange}
                                />
                            </label>
                        </div>
                    </div>
                ) : (
                    <div className="headerTitle flex_c" ref={dropdownRef}>
                        <span className="revision_title title22">22개정</span>
                        <h3 className="dataTitle">
                            {
                                sTextbookList.find((el) => el.curriBook === sCurribook?.curriBook)
                                    ?.name
                            }
                        </h3>
                        <button
                            type="button"
                            className={`btn btn-dropdown arrow ${open ? 'on' : ''}`}
                            onClick={() => {
                                const dataListLayer = document.querySelector('.data-list-layer');
                                const btnDropdown = document.querySelector('.btn-dropdown');
                                setOpen(!open);
                            }}
                        >
                            <span className="blind">열기</span>
                        </button>
                        <div className={`data-list-layer ${open ? 'on' : ''}`}>
                            <div className="scroll-inner">
                                <ul>
                                    {sTextbookList.map((textbook) => {
                                        return (
                                            <li
                                                className={`${textbook.id === textbookId && 'current'}`}
                                                onClick={() => handleChangeBook(textbook)}
                                            >
                                                <a href="#">{textbook.name}</a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

                {type === 'editMode' ? (
                    <div className="btn-group">
                        {publishId == undefined && (
                            <button
                                className="btn btn-default darkblue wid_ name_save"
                                onClick={handleNewSave}
                            >
                                다른 이름으로 저장하기
                            </button>
                        )}
                        <button
                            className="btn btn-default darkblue wid_ data_save"
                            onClick={handleSave}
                        >
                            저장하기
                        </button>
                        <button className="btn btn-icon exit " onClick={showExitPopup}>
                            <i></i>
                            <span className="blind">나가기</span>
                        </button>
                    </div>
                ) : (
                    <div className="btn-group">
                        <button
                            className="btn btn-default icon blue arrow_left_w btn-prev"
                            onClick={onGoBack}
                        >
                            <i></i>이전 페이지
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GnbMenu;
